import FollowTechniaHQ from "./FollowTechniaHQ";

export default function CTASection() {
  return <FollowTechniaHQ />;
}
